import { getRequiredMessage } from '@monetize/types/common';
import { z } from 'zod';

export const ESignRecipientSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  order: z.string(),
  status: z.string(),
  declinedDateTime: z.string().nullish(),
  deliveredDateTime: z.string().nullish(),
  sentDateTime: z.string().nullish(),
  signedDateTime: z.string().nullish(),
});

export type ESignRecipient = z.infer<typeof ESignRecipientSchema>;

export const ESignRecipientResponseSchema = z.object({
  recipientCount: z.string(),
  currentRoutingOrder: z.string(),
  signers: ESignRecipientSchema.array(),
  ccContacts: ESignRecipientSchema.array(),
});

export type ESignRecipientResponse = z.infer<
  typeof ESignRecipientResponseSchema
>;

export enum ESignAccountBaseUrlEnum {
  DEMO = 'https://demo.docusign.net',
  PRODUCTION = 'https://www.docusign.net',
  PRODUCTION_EU = 'https://eu.docusign.net',
}

export const EsignAccountBaseUrlEnumZ = z.enum(ESignAccountBaseUrlEnum);

export const ESignProvider = z.enum(['DOCUSIGN', 'ADOBE_ACROBAT_SIGN']);

export type ESignProvider = z.infer<typeof ESignProvider>;

export const AdobeAcrobatSignConfigSchema = z.object({
  provider: z.literal('ADOBE_ACROBAT_SIGN'),
  accessToken: z.string(),
  refreshToken: z.string(),
  apiAccessPoint: z.string(),
  webAccessPoint: z.string(),
});

export type AdobeAcrobatSignConfig = z.infer<
  typeof AdobeAcrobatSignConfigSchema
>;

export const DocusignConfigSchema = z.object({
  provider: z.literal('DOCUSIGN'),
  userId: z.string(),
  accountId: z.string().nullish(),
  hmacKey: z.string(),
  hmacKeyId: z.string().nullish(),
  accountBaseURI: z.string(),
});

export type DocusignConfig = z.infer<typeof DocusignConfigSchema>;

export const DocusignFormSchema = z.object({
  provider: z.literal('DOCUSIGN'),
  userId: z.uuid().nonempty(getRequiredMessage('User ID')),
  hmacKey: z.string().nonempty(getRequiredMessage('HMAC Key')),
  accountBaseURI: EsignAccountBaseUrlEnumZ,
  accountId: z.string().nullish(),
});

export type DocusignForm = z.infer<typeof DocusignFormSchema>;

export const ESignConfigSchema = z.discriminatedUnion('provider', [
  DocusignConfigSchema,
  AdobeAcrobatSignConfigSchema,
]);

export type ESignConfig = z.infer<typeof ESignConfigSchema>;
